WiseMetering.Views.NewNextbittMaintenanceConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/nextbitt_maintenance/new',
    title: () => i18next.t('modal.title.integration_configurations.new'),
    buttons: ['save', 'cancel'],

    events: {
        'click #search_button': 'search',
        'keyup input#search_text': 'onSearchType'
    },

    ui: {
        name: '#integration_configuration_name',
        search: '#search_text',
        site_reference: '#integration_configuration_site_reference',
        sites: '#integration_configuration_site_id',
        api_key: '#integration_configuration_api_key',
        url: '#integration_configuration_url'
    },

    fetchExternalSites: function(apiKey, baseUrl) {
        this.modal.block();

        const payload = {
            license_id: this.model.get('license_id'),
            search_text: this.ui.search.val(),
            api_key: apiKey,
            url: baseUrl
        };

        $.ajax({
            url: '/integration_configurations/external_sites',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: function(data) {
                this.externalSites = data;
                $('#save').prop('disabled', false);
                this.ui.api_key.prop('disabled', true);
                this.ui.site_reference.prop('disabled', false);
                this.ui.url.prop('disabled', true);
                this.ui.site_reference.empty();
                this.optionsFromData(data);

                this.modal.unblock();
            }.bind(this),
            error: function(e) {
                WiseMetering.layout.showTipper('error', e.responseJSON.error);
                $('#save').prop('disabled', true);
                this.ui.api_key.prop('disabled', false);
                this.ui.url.prop('disabled', false);
                this.modal.unblock();
            }.bind(this)
        });
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.site_reference_name = this.ui.site_reference.find(':selected').text();
        return data;
    },

    onSearchType: function(event) {
        if (event && (event.keyCode || event.which) !== 13) {
            return;
        }

        this.search();
    },

    onShow: function() {
        const
            usedSiteIds = this.model.license().configurations().pluck('site_id'),
            sites = WiseMetering.zones.sites().models.filter(site => !usedSiteIds.includes(site.id));

        $('#save').prop('disabled', true);

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites));
    },

    optionsFromData: function(data) {
        if (data.length === 0) {
            this.ui.site_reference.append(new Option('No results found', ''));
            this.ui.site_reference.prop('disabled', true);
        } else {
            data.forEach(function(item) {
                this.ui.site_reference.append(new Option(`${item.site_reference} - ${item.site_reference_name}`, item.site_reference));
            }.bind(this));
        }
    },

    search: function() {
        const
            baseUrl = this.ui.url.val(),
            apiKey = this.ui.api_key.val();

        if (baseUrl.length < 1 || baseUrl === i18next.t('integrations.insert_url')) {
            WiseMetering.layout.showTipper('error', i18next.t('integrations.insert_url'));

            $('#integration_url').val(i18next.t('integrations.insert_url'));
            return;
        }

        if (apiKey.length < 1 || apiKey === i18next.t('integrations.insert_api_key')) {
            WiseMetering.layout.showTipper('error', i18next.t('integrations.insert_token'));

            $('#integration_configuration_api_key').val(i18next.t('integrations.insert_token'));
            return;
        }

        this.externalSites = this.fetchExternalSites(apiKey, baseUrl);
    }
});
